<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFileOutline } from "@mdi/js";
export default {
  name: "MdiFileOutline",
  data() {
    return {
      svgPath: mdiFileOutline,
    };
  },
};
</script>
